import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'src/redux/index';
import getCreditsConsumptionHistory, {
  getUserSkills,
  uploadUserFeedbackMedia,
} from '../actions';
import type { JobState } from './types/index';

const initialState: JobState = {
  fetchingCreditsHistory: false,
  isFetchingSkills: false,
  isUploadingFeedbackImage: false,
};

/* eslint-disable no-param-reassign */
const sharedSlice = createSlice({
  name: 'Shared',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCreditsConsumptionHistory.fulfilled, (state, action) => {
      state.creditsHistory = action.payload;
      state.fetchingCreditsHistory = false;
    });
    builder.addCase(getCreditsConsumptionHistory.pending, (state) => {
      state.fetchingCreditsHistory = true;
    });
    builder.addCase(getCreditsConsumptionHistory.rejected, (state) => {
      state.fetchingCreditsHistory = false;
    });
    builder
      .addCase(getUserSkills.rejected, (state) => {
        state.isFetchingSkills = false;
      })
      .addCase(getUserSkills.pending, (state) => {
        state.isFetchingSkills = true;
      });
    builder.addCase(uploadUserFeedbackMedia.pending, (state) => {
      state.isUploadingFeedbackImage = true;
    });
    builder.addCase(uploadUserFeedbackMedia.fulfilled, (state) => {
      state.isUploadingFeedbackImage = false;
    });
    builder.addCase(uploadUserFeedbackMedia.rejected, (state) => {
      state.isUploadingFeedbackImage = false;
    });
  },
});
/* eslint-enable no-param-reassign */

const { reducer } = sharedSlice;

export default reducer;
export const sharedLayoutSelector = (state: RootState) => state.sharedLayout;
